export type Config = {
  clientId: string;
  tenantId: string;
  authorityUri: string;
  redirectUri: string;
  tokenScopes: string[];
  cacheLocation: string;
  secureCookies: boolean;
  drillx_id3_api_url: string;
  drillx_wg_api_url: string;
  drillx_gm_depthlog_api_url: string;
  enableDebugLogs?: boolean;
  storeAuthStateInCookie?: boolean;
  env_id: string;
  instrumentationKey: string;
  apim_subscription_key: string;
  apim_trace: string;
  hotjar_site_id: string;
  app_version: string;
};

export const EnvConfig: Config = {
  cacheLocation: 'localStorage',
  clientId: '{CLIENT_ID}',
  tenantId: '{TENANT_ID}',
  secureCookies: !!String('{SECURE_COOKIES}'),
  drillx_id3_api_url: '{DRILLX_ID3_API_URL}',
  drillx_wg_api_url: '{DRILLX_WG_API_URL}',
  drillx_gm_depthlog_api_url: '{DRILLX_GM_DEPTHLOG_API_URL}',
  redirectUri: '{REDIRECT_URI}',
  tokenScopes: '{AAD_BACKEND_SCOPE}'.split(','),
  enableDebugLogs: !!String('{ENABLE_DEBUG_LOGS}'),
  authorityUri: '{TENANT_AUTHORITY_URI}',
  //  tokenScopes: [process.env.REACT_APP_BACKEND_PERMISSION_URI],
  env_id: '{ENV_ID}',
  instrumentationKey: '{APPLICATION_INSIGHTS_INSTRUMENTATION_KEY}',
  apim_subscription_key: '{APIM_SUBSCRIPTION_KEY}',
  apim_trace: '{APIM_TRACE}',
  hotjar_site_id: '{HOTJAR_SITE_ID}',
  app_version: '{APP_VERSION}',
};
